// import "./BusinessList1.css";
import React, { useEffect, useState } from "react";
import Axios from '../../../services/AxiosInstance';
import preferenceKey from "../../common/constVariable";


import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
// import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#348cd4',
    },
}));

function Preference() {
    const classes = useStyles();
    const [loader, setLoader] = useState({ isOpen: false, isData: '' });

    const [keyArr, setKeyArr] = useState(preferenceKey);
    const [preference_name, setPreference_name] = useState('');
    const [key, setKey] = useState('');
    const [reminder_duration, setReminderDuration] = useState('');
    const [no_of_reminder, setNoOfReminder] = useState('');

    const [emailVar, setEmailVar] = useState({ key: preferenceKey[0], preference_name: "", reminder_duration: "", no_of_reminder: "" });
    const [planExpired, setPlanExpired] = useState({ key: preferenceKey[1], preference_name: "", reminder_duration: "", no_of_reminder: "" });

    useEffect(() => {
        getData();
    }, [])
    const handlePreferenceApi = (key) => {
        // console.log(key);
        let data = {}
        if (key === preferenceKey[0]) {
            data.preference_name = emailVar.preference_name;
            data.key = emailVar.key;
            data.reminder_duration = emailVar.reminder_duration;
            data.no_of_reminder = emailVar.no_of_reminder
        }
        if (key === preferenceKey[1]) {
            data.preference_name = planExpired.preference_name;
            data.key = planExpired.key;
            data.reminder_duration = planExpired.reminder_duration;
            data.no_of_reminder = planExpired.no_of_reminder
        }

        if (data) {
            console.log("asdsasds", data);
            Axios.post(`api/business/application-preferences`, data, setLoader({ isOpen: true }))
                .then((res) => {
                    setLoader({ isOpen: false })
                    // console.log(res);
                })
                .catch((error) => {
                    setLoader({ isOpen: false })
                    console.log(error);
                })
        }


    }

    const getData = () => {
        Axios
            .get(`api/business/application-preference-data`)
            .then((res) => {
                // console.log("asdasdasds", res);
                if (res?.data?.data?.length > 0) {
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].key === preferenceKey[0]) {
                            setEmailVar(({ key: preferenceKey[0], preference_name: res.data.data[i].preference_name, reminder_duration: res.data.data[i].reminder_duration, no_of_reminder: res.data.data[i].no_of_reminder }))
                        }
                        if (res.data.data[i].key === preferenceKey[1]) {
                            setPlanExpired(({ key: preferenceKey[1], preference_name: res.data.data[i].preference_name, reminder_duration: res.data.data[i].reminder_duration, no_of_reminder: res.data.data[i].no_of_reminder }))
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }


    // const getData = (e) => {
    //     setKey(e.target.value);
    //     console.log(e.target.value);
    //     Axios
    //         .get(`api/business/application-preference-data?key=${e.target.value}`)
    //         .then((res) => {
    //             // console.log(res.data.data[0].preference_name);
    //             if (res?.data?.data?.length > 0) {
    //                 setPreference_name(res.data.data[0].preference_name);
    //                 setReminderDuration(res.data.data[0].reminder_duration);
    //                 setNoOfReminder(res.data.data[0].no_of_reminder);
    //             }
    //             else {
    //                 setPreference_name('');
    //                 setReminderDuration('');
    //                 setNoOfReminder('');
    //             }

    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    // }

    const keyOption = keyArr.map((item, index) => {
        return (
            <option onClick={getData}>{item}</option>
        )
    })

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Application Preferences</h4>
                                </div>
                                <div className="card-box">

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label >Key</label>
                                                <input
                                                    // onChange={(e) => setEmailVar(e.target.value)}
                                                    value={emailVar.key}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Key"
                                                    readOnly
                                                />
                                                {/* <select
                                                    onChange={(e) => { getData(e) }}
                                                    id="key"
                                                    type="text"
                                                    className="form-control"
                                                >
                                                    <option>Select Key</option>
                                                    {keyOption}
                                                </select> */}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label >Preference Name</label>
                                                <input
                                                    onChange={(e) => setEmailVar({ ...emailVar, preference_name: e.target.value })}
                                                    value={emailVar.preference_name}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter the Preference Name"
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                <label >Reminder Duration</label>
                                                <input
                                                    onChange={(e) => setEmailVar({ ...emailVar, reminder_duration: e.target.value })}
                                                    id="reminder-duration"
                                                    value={emailVar.reminder_duration}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter duration"
                                                />
                                            </div>
                                        </div>


                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                <label htmlFor="Num-Reminder">Number of Reminder</label>
                                                <input
                                                    onChange={(e) => setEmailVar({ ...emailVar, no_of_reminder: e.target.value })}

                                                    value={emailVar.no_of_reminder}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Number of Reminder"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group mb-0 text-center">
                                                <label >Action</label>
                                                <button className="btn btn-gradient btn-block action-btn" onClick={() => handlePreferenceApi(emailVar.key)} type="submit"> Submit </button>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                {/* <label htmlFor="key">Key</label> */}
                                                <input
                                                    // onChange={(e) => setPlanExpired(e.target.value)}

                                                    value={planExpired.key}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Key"
                                                    readOnly
                                                />
                                                {/* <select
                                                    onChange={(e) => { getData(e) }}
                                                    id="key"
                                                    type="text"
                                                    className="form-control"
                                                >
                                                    <option>Select Key</option>
                                                    {keyOption}
                                                </select> */}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                {/* <label htmlFor="preference-name">Preference Name</label> */}
                                                <input
                                                    onChange={(e) => setPlanExpired({ ...planExpired, preference_name: e.target.value })}

                                                    value={planExpired.preference_name}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter the Preference Name"
                                                    readOnly

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                {/* <label htmlFor="reminder-duration">Reminder Duration</label> */}
                                                <input
                                                    onChange={(e) => setPlanExpired({ ...planExpired, reminder_duration: e.target.value })}

                                                    value={planExpired.reminder_duration}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter duration"
                                                    
                                                />
                                            </div>
                                        </div>


                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                {/* <label htmlFor="Num-Reminder">Number of Reminder</label> */}
                                                <input
                                                    onChange={(e) => setPlanExpired({ ...planExpired, no_of_reminder: e.target.value })}
                                                    value={planExpired.no_of_reminder}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Number of Reminder"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group mb-0 text-center">
                                                {/* <label htmlFor="Num-Reminder">Action</label> */}
                                                <button className="btn btn-gradient btn-block action-btn" onClick={() => handlePreferenceApi(planExpired.key)} type="submit"> Submit </button>
                                            </div>
                                        </div>

                                    </div>



                                </div>



                            </div>
                        </div>
                    </div>
                </div>
                {loader.isOpen ?
                    <Backdrop className={classes.backdrop} open>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : ""}
            </div>

        </>
    );
}

export default Preference;